import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import MainSection from "../../components/mainLayout/Main";
import { addService, getAllDepartments, } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


function AddService() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const departments = useSelector(state => state.auth.departments);

	const [formData, setFormData] = useState({
		name: "",
		department: "",
	});

	useEffect(() => {
		async function func() {
			try {
				await dispatch(getAllDepartments());
			} catch (err) {
				console.error(err);
			}
		}
		func();
	}, [dispatch]);

	// const handleChange = (e) => {
	// 	setFormData({ ...formData, [e.target.id]: e.target.value });
	// }
	const handleChange = (e) => {
		const { id, value } = e.target;
		if (id === "name") {
			// Only allow letters and spaces (no numbers)
			const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
			setFormData({ ...formData, [id]: lettersOnly });
		} else {
			setFormData({ ...formData, [id]: value });
		}
	};
 // eslint-disable-next-line 
	const handleSelectChange = (value) => {
		setFormData({
			...formData,
			compliance: value.value
		});
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		try { // eslint-disable-next-line 
			const response = await dispatch(addService(formData));
			navigate("/services");
		} catch (error) {
			console.error("Error in handleSubmit:", error);
		}
	};
 // eslint-disable-next-line 
	const serviceOptions = [{ value: true, label: "Yes" }, { value: false, label: "No" }];

	return (
		<div>
			<Sidebar />

			<MainSection>
				<SectionHeader title="Add Service" />

				<div className="container w-full md:w-1/2 lg:w-1/3 text-start">
					<form onSubmit={handleSubmit}>
						{/* Name Input */}
						<div className="my-5">
							<label
								htmlFor="name"
								className="block mb-2 text-sm font-medium text-gray-900"
							>
								Service Name
							</label>
							<input
								type="text"
								id="name"
								value={formData.name}
								onChange={handleChange}
								className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
								placeholder="Enter the Services"
								required
							/>
						</div>


						{/* Client Type */}
						<div className="mb-5">
							<label
								htmlFor="department"
								className="block mb-2 text-sm font-medium text-gray-900"
							>
								Department
							</label>
							<select
    id="department"
    onChange={handleChange}
    value={formData.department}
    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
    required
>
    <option value="" disabled>Select Department</option>
    {departments && departments.length > 0 ? (
        departments.map((d) => (
            <option key={d._id} value={d._id}> {/* Added key={d._id} here */}
                {d.name}
            </option>
        ))
    ) : (
        <option disabled>No Departments Available</option>
    )}
</select>
						</div>

						<button
							type="submit"
							className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-[#045B9B] hover:bg-[#3385c0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
						>
							Add Service
						</button>
					</form>
				</div>
			</MainSection>
		</div>
	);
}

export default AddService;
